export default __webpack_public_path__ + "static/media/1st-place-badge.9420c289.svg";